import {
  NEWLIST_FETCHITEMS_LOAD,
  NEWLIST_FETCHITEMS_SUCCEED,
  NEWLIST_FETCHITEMS_FAIL,
  NEWLIST_CHANGETABLE_CHANGE,
  NEWLIST_SEARCHTABLE_EDIT,
  NEWLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case NEWLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case NEWLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case NEWLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case NEWLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case NEWLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case NEWLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
